import { render, staticRenderFns } from "./hub_details.vue?vue&type=template&id=ed3f6e2a"
import script from "./hub_details.vue?vue&type=script&lang=js"
export * from "./hub_details.vue?vue&type=script&lang=js"
import style0 from "./hub_details.vue?vue&type=style&index=0&id=ed3f6e2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports